export const dimBlue = {
  50: '#06070A',
  100: '#0B0E13',
  150: '#11161D',
  200: '#171D26',
  250: '#1D2430',
  300: '#222B3A',
  350: '#283243',
  400: '#2E3A4D',
  450: '#334156',
  500: '#394860',
  550: '#4D5A70',
  600: '#616D80',
  650: '#747F90',
  700: '#8891A0',
  750: '#9CA3AF',
  800: '#B0B6BF',
  850: '#C4C8CF',
  900: '#D7DADF',
  950: '#EBEDEF',
  975: '#F5F6F7',
  990: '#FBFBFC',
} as const;
